import {BaseDtoModel} from '../../Services/Models/base-model.service';
import {endOfMonth, format, startOfMonth, sub} from 'date-fns';

export class ExpensesReviewFilters extends BaseDtoModel {
  tipo_fecha!: 'week' | 'month' | 'trimester' | 'year';
  fecha_desde!: string;
  fecha_hasta!: string;
  filtro_local!: number;
  pending_review!: number;

  constructor(dataJson?: any) {
    super(dataJson);

    this.init({
      tipo_fecha: 'month',
      fecha_desde: format(startOfMonth(new Date()), 'yyyy-MM-dd'),
      fecha_hasta: format(endOfMonth(new Date()), 'yyyy-MM-dd'),
      filtro_local: 0,
      pending_review: 0,
    });
  }


  /**
   * Crear filtros para la revisión de gastos con un rango de 4 años
   *
   */
  static forReview(storeId: number): ExpensesReviewFilters {
    const filters = new ExpensesReviewFilters();
    filters.filtro_local = storeId;
    filters.fecha_desde = format(sub(new Date(), {years: 4}), 'yyyy-MM-dd');
    filters.fecha_hasta = format(new Date(), 'yyyy-MM-dd');
    filters.pending_review = 1;

    return filters;
  }

}
